import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';
import { ActivityLogQueryParams } from '../types/activityLog';

/**
 * Query key filter for activity log list queries
 * Extends with all the filter params from ActivityLogQueryParams
 */
interface ActivityLogQueryListKeyFilter extends RequiredQueryKeyFilter, ActivityLogQueryParams {}

/**
 * Query key filter for activity log detail queries (by ID)
 */
interface ActivityLogQueryDetailKeyFilter extends RequiredQueryKeyFilter {
  id: string;
}

/**
 * Activity log query keys generator
 */
export const activityLogQueryKeys = createDefaultQueryKeysGenerator<
  ActivityLogQueryListKeyFilter,
  ActivityLogQueryDetailKeyFilter
>({
  keyDataType: 'activityLogs',
});
